module.exports = __webpack_public_path__ + "img/flags/TW.946fea0.png";